module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2aFE8"))).then(() => parcelRequire('cvs7o'));